import { render, staticRenderFns } from "./RoundtableAdd.vue?vue&type=template&id=8d2de08a&"
import script from "./RoundtableAdd.vue?vue&type=script&lang=js&"
export * from "./RoundtableAdd.vue?vue&type=script&lang=js&"
import style0 from "./RoundtableAdd.vue?vue&type=style&index=0&id=8d2de08a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports